import { Box, Button, Grid, Typography } from "@mui/material";
import Tuffy from "src/assets/Tuffy_Buy.png";
import { USE_BASE_URL } from "src/config";

const Terms = () => {
  return (
    <>
      <Box className="main" mt={5}>
        <Box className="section banner banner-section">
          <Box className="container ">
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={1}></Grid>
                <Grid item xs={12} md={10}>
                  <Box mt={3}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box>
                          <Typography
                            variant="h4"
                            className="terms-head"
                            sx={{ position: "relative", textAlign: "center" }}
                          >
                            STAKING <br />
                            TERMS & CONDITIONS
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: 3,
                            }}
                          >
                            <Button
                              size="large"
                              variant="contained"
                              className="buy-btn"
                              sx={{
                                textTransform: "capitalize",
                                fontWeight: 700,
                              }}
                              href={`${USE_BASE_URL}/terms-and-conditions/#staking`}
                              target="_blank"
                            >
                              Staking / Unstaking Terms
                            </Button>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box>
                          <img src={Tuffy} className="tuffy-secure-img" />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} md={1}></Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Terms;
